import { render, staticRenderFns } from "./ResourceReference.vue?vue&type=template&id=e8797068&scoped=true&"
import script from "./ResourceReference.vue?vue&type=script&lang=js&"
export * from "./ResourceReference.vue?vue&type=script&lang=js&"
import style0 from "./ResourceReference.vue?vue&type=style&index=0&id=e8797068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8797068",
  null
  
)

export default component.exports